<template>
  <div>
    <!--begin::Content header-->
    <div
      class="position-absolute top-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10"
    >
      <router-link
        class="font-weight-bold font-size-3 ml-2 text-danger"
        :to="{ name: 'login' }"
      >
        Login
      </router-link>
    </div>
    <!--end::Content header-->

    <!--begin::Signup-->
    <div class="login-form login-signin">
      <div class="text-center my-10 my-lg-10">
        <h3 class="font-size-h1">Change your Password</h3>
      </div>

      <!--begin::Form-->
      <b-form class="form" @submit.stop.prevent="onSubmit">
        <b-form-group
          id="example-input-group-1"
          label=""
          label-for="example-input-1"
        >
          <b-form-input
            type="password"
            class="form-control form-control-solid h-auto py-5 px-6"
            id="example-input-1"
            name="example-input-1"
            v-model="$v.form.password.$model"
            :state="validateState('password')"
            aria-describedby="input-1-live-feedback"
            placeholder="Password"
          ></b-form-input>

          <b-form-invalid-feedback id="input-1-live-feedback">
            Minimum 6 characters
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          id="example-input-group-2"
          label=""
          label-for="example-input-2"
        >
          <b-form-input
            type="password"
            class="form-control form-control-solid h-auto py-5 px-6"
            id="example-input-2"
            name="example-input-2"
            v-model="$v.form.repassword.$model"
            :state="validateState('repassword')"
            aria-describedby="input-1-live-feedback"
            placeholder="Re-enter Password"
          ></b-form-input>

          <b-form-invalid-feedback id="input-1-live-feedback">
            Fields not match
          </b-form-invalid-feedback>
        </b-form-group>

        <!--begin::Action-->
        <div class="form-group d-flex flex-wrap flex-center">
          <button
            type="submit"
            ref="kt_login_signup_submit"
            class="btn btn-success font-weight-bold px-9 py-4 my-3 font-size-3 mx-4"
          >
            Change Password
          </button>
          <button
            v-on:click="$router.push('login')"
            class="btn btn-light-success font-weight-bold px-9 py-4 my-3 font-size-3 mx-4"
          >
            Cancel
          </button>
        </div>
        <!--end::Action-->
      </b-form>
      <!--end::Form-->
    </div>
    <!--end::Signup-->
  </div>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>

<script>
// @ is an alias to /src
import axios from "axios";
import Swal from "sweetalert2";
import { validationMixin } from "vuelidate";
import { minLength, required, sameAs } from "vuelidate/lib/validators";

export default {
  name: "recover",
  mixins: [validationMixin],
  data() {
    return {
      form: {
        repassword: "",
        password: ""
      },
      message: "Escriu un nou mot de pas",
      isActive: false
    };
  },
  validations: {
    form: {
      password: {
        required,
        minLength: minLength(6)
      },
      repassword: {
        required,
        sameAsPassword: sameAs("password")
      }
    }
  },
  beforeCreate() {
    const token = this.$route.query.t;
    console.log(token);
    axios.defaults.headers = {
      Authorization: "Bearer " + token
    };
    axios
      .get("/verify")
      .then(res => {
        console.log(res.data);
        this.id = res.data.user.userId;
        this.isActive = true;
      })
      .catch(error => {
        console.log(error.response);
        this.message =
          "Token no valid. Hi ha hagut un error a l'hora de recuperar el mot de pas. Sis plau, ves a Login i torna a intentar-ho.";
      });
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      axios
        .put("changePass/" + this.id, { password: this.form.password })
        .then(response => {
          if (response.status == 200) {
            Swal.fire({
              title: "Password Changed",
              text: "",
              icon: "success"
            });
          }
          this.$router.push({ name: "login" });
          this.message = "Password recuperat. Ves a Login per continuar";
        })
        .catch(error => {
          console.log(error.response);
        });
    }
  }
};
</script>
